import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/hooks/useAuth';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Login } from '@/pages/auth/Login';
import { TwoFactor } from '@/pages/auth/TwoFactor';
import { TotpSetup } from '@/pages/auth/TotpSetup';
import { ForceChangePassword } from '@/pages/auth/ForceChangePassword';
import { ForgotPassword } from '@/pages/auth/ForgotPassword';
import { ResetPassword } from '@/pages/auth/ResetPassword';
import { Dashboard } from '@/pages/Dashboard';
import { Viewer } from '@/pages/Viewer';
import { Publish } from '@/pages/publish/Publish';
import { Collections } from '@/pages/Collections';
import { Channels } from '@/pages/Channels';
import { Users } from '@/pages/admin/Users';
import { Publishers } from '@/pages/admin/Publishers';
import { Guide } from '@/pages/Guide';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public auth flow */}
          <Route path="/login" element={<Login />} />
          <Route path="/2fa" element={<TwoFactor />} />
          <Route path="/totp-setup" element={<TotpSetup />} />
          <Route path="/force-change-password" element={<ForceChangePassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Authenticated */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/view/:id"
            element={
              <ProtectedRoute>
                <Viewer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/publish"
            element={
              <ProtectedRoute publisherOnly>
                <Publish />
              </ProtectedRoute>
            }
          />
          <Route
            path="/collections"
            element={
              <ProtectedRoute publisherOnly>
                <Collections />
              </ProtectedRoute>
            }
          />
          <Route
            path="/channels"
            element={
              <ProtectedRoute publisherOnly>
                <Channels />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute publisherOnly>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/publishers"
            element={
              <ProtectedRoute platformOnly>
                <Publishers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/guide"
            element={
              <ProtectedRoute>
                <Guide />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" toastOptions={{ style: { fontFamily: 'Montserrat, sans-serif' } }} />
      </AuthProvider>
    </BrowserRouter>
  );
}
